
import { defineComponent, onErrorCaptured, reactive, watch } from 'vue';
import * as Sentry from '@sentry/vue';
import { useGtm } from 'vue-gtm';
import { Component } from 'vue';
import { useRoute } from 'vue-router/composables';

export default defineComponent({
  name: 'ErrorBoundary',

  props: {
    error: {
      type: Error,
      default: undefined,
    },
  },

  setup(props) {
    const route = useRoute();
    const state = reactive<{ err?: Error; vm?: Component; info?: string }>({
      err: undefined,
      vm: undefined,
      info: undefined,
    });

    const errorHandler = (err: Error) => {
      console.error(err);
      Sentry.captureException(err);

      // Google Tag Managerへカスタムイベントを送出する
      const gtm = useGtm();
      gtm?.trackEvent({ event: 'error' });
    };

    onErrorCaptured((err: any, vm: any, info: any) => {
      state.err = err;
      state.vm = vm;
      state.info = info;

      errorHandler(err);

      return false;
    });

    const clear = () => {
      state.err = state.vm = state.info = undefined;
    };

    watch(
      () => props.error,
      err => {
        if (err) {
          state.err = err;
          errorHandler(err);
        }
      },
      { immediate: true }
    );

    watch(
      () => route.fullPath,
      () => clear()
    );

    return {
      state,
    };
  },
});
